import { registrationEvents } from "../trackingEventNames";

export type RegistrationFailureOutcome = "auth_failed" | "forbidden" | "b2c_error";

export interface RegistrationFailureInput {
  isSignUpFlow: boolean;
  outcome: RegistrationFailureOutcome;
  status?: number;
  errorCode?: string;
  errorDescription?: string;
  clientCode?: string;
}

export interface RegistrationFailureEvent {
  name: string;
  properties: Record<string, string>;
}

// Returns the telemetry event to emit for a failed Investor Portal sign-up code
// exchange, or null when the failure must not alarm (non-sign-up flow, or the
// benign "authenticated but not invited" 403 — which has its own troubleshooter).
// clientCode (when resolvable from the OAuth state) is attached so the alarm can be
// triaged to the affected client.
export const getRegistrationFailureEvent = (input: RegistrationFailureInput): RegistrationFailureEvent | null => {
  const { isSignUpFlow, outcome, status, errorCode, errorDescription, clientCode } = input;

  if (!isSignUpFlow) {
    return null;
  }

  if (outcome === "auth_failed") {
    return {
      name: registrationEvents.FAILED,
      properties: {
        reason: "code_exchange_failed",
        ...(status !== undefined ? { status: String(status) } : {}),
        ...(clientCode ? { clientCode } : {}),
      },
    };
  }

  if (outcome === "b2c_error") {
    return {
      name: registrationEvents.FAILED,
      properties: {
        reason: "b2c_error",
        ...(errorCode ? { errorCode } : {}),
        ...(errorDescription ? { errorDescription } : {}),
        ...(clientCode ? { clientCode } : {}),
      },
    };
  }

  return null; // "forbidden" → benign not-invited
};
